import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'

import { DELIVERY } from 'containers/AwarenessCenter/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  fetchRecipientsError,
  fetchRecipientsSuccess,
  updateDataError,
  updateDataSuccess,
} from './actions'
import {
  CHANGE_RECIPIENTS_SEARCH_FILTER,
  DATA_UPDATE_ASYNC,
  RECIPIENTS_COUNT_REQUEST_ASYNC,
  RECIPIENTS_REQUEST_ASYNC,
} from './constants'

const updateDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DATA_UPDATE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .updateAnnouncementLocale(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.data
        )
        .pipe(
          mergeMap((response) =>
            of(updateDataSuccess(response), addToast({ message: 'Updated!' }))
          ),
          catchError((error) =>
            of(
              epicsErrorHandler(updateDataError, error),
              addToast({
                message: error.response?.message,
                type: 'error',
                id: 'End_User_Notification_Editor_Update_Error',
              })
            )
          ),
          takeUntil(action$.pipe(ofType(DATA_UPDATE_ASYNC.CANCEL)))
        )
    )
  )

const fetchRecipientsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(RECIPIENTS_REQUEST_ASYNC.INITIATE, CHANGE_RECIPIENTS_SEARCH_FILTER),
    mergeMap(() =>
      api.settings
        .fetchAnnouncementsParticipants(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.partnerOptions.selectedCompany?.value || state$.value.app.data.id,
          {
            searchFilter: state$.value.settings.notifications.editor.recipientsSearchFilter,
          }
        )
        .pipe(
          map((response) => fetchRecipientsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchRecipientsError, error))),
          takeUntil(action$.pipe(ofType(RECIPIENTS_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const fetchRecipientsCountEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(RECIPIENTS_COUNT_REQUEST_ASYNC.INITIATE),
    switchMap((action) =>
      api.settings
        .fetchAnnouncementsRecipientsCount(state$.value.partnerOptions.selectedCompany?.value, {
          deliveryType: DELIVERY.EMAIL,
          groups: action.payload.groups,
        })
        .pipe(
          map(({ response }) => RECIPIENTS_COUNT_REQUEST_ASYNC.onSuccess(response)),
          catchError((error) =>
            of(epicsErrorHandler(RECIPIENTS_COUNT_REQUEST_ASYNC.onError, error, [400]))
          ),
          takeUntil(action$.pipe(ofType(RECIPIENTS_COUNT_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(updateDataEpic, fetchRecipientsEpic, fetchRecipientsCountEpic)
